import { useContext } from "react";
import { GlobalDialogBloc } from "./GlobalDialogBloc";
import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";

export const GlobalDialogContext = createBlocContext<GlobalDialogBloc>();

export function useGlobalDialogContext() {
  const ctx = useContext(GlobalDialogContext);
  return ctx;
}

export const GlobalDialogBlocProvider = createBlocProvider<GlobalDialogBloc>(
  GlobalDialogBloc.create(),
  GlobalDialogContext
);
